export enum KeyNodeType {
  ControlKeyMaster = 1,
  ControlKey = 2,
  ConstructionKeyMaster = 3,
  ConstructionKey = 4,
  SingleKeyDifferentMaster = 5,
  SingleKeyDifferent = 6,
  DirectChangeMaster = 7,
  Direct = 8,
  Master = 9,
  ChangeKey = 10,
  SelectiveMaster = 11,
  CrossKeyMaster = 12,
  CrossKeyChild = 13,
  OrphanMaster = 14,
  Orphan = 15,
  FutureKey = 16,
  Insert = 17,
  ChangeKeyThruNode = 99,
  SingleKeyDifferentThruNode = 100,
}
